import URI from 'urijs';
import { PushClient } from './util/PushClient';
import { Site } from 'src/components/modules/sites/types';

export class SiteApi extends PushClient {
  public async getSite(siteId: number): Promise<Site> {
    const uri = new URI(SiteApiPathBuilder.GET_SITE(siteId)).toString();
    const site = await this.client.get<Site>(uri);

    return site;
  }
}

export class SiteApiPathBuilder {
  static GET_SITE = (siteId: number) => `/sites/${siteId}/settings`;
}
